// Dynamic redirect URI for production - will use the actual deployed domain
const getCurrentOrigin = () => {
    if (typeof window !== 'undefined' && window.location) {
        return window.location.origin;
    }
    // Fallback during build time or SSR
    return 'https://tms.zilon.com';
};

export const environment = {
    production: true,
    apiUrl: 'https://znem-fgdgb0d4fcgbg4c6.southeastasia-01.azurewebsites.net/api',
    graphqlUrl: '/api/graphql',
    msalConfig: {
        auth: {
            clientId: '973c9cf5-83fd-4052-903b-7ac24c2cee9b', // Replace with your production client ID
            authority: 'https://login.microsoftonline.com/09c7db79-cb84-41e2-bcb8-66a3b0d15d83', // Replace with your actual tenant ID
            redirectUri: getCurrentOrigin(),
            postLogoutRedirectUri: getCurrentOrigin(),
            navigateToLoginRequestUrl: false
        }
    },
    useMockAuth: false
};